import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import VinduespudsningPage from "./pages/VinduespudsningPage";
import FliserensPage from "./pages/FliserensPage";
import SolcellevaskPage from "./pages/SolcellevaskPage";
import CityPage from "./pages/CityPage";
import CitiesOverviewPage from "./pages/CitiesOverviewPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForbiddenPage from "./pages/ForbiddenPage";
import { CITY_PAGES } from "./data/siteData";

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-white text-slate-900 selection:bg-cyan-500 selection:text-white font-sans">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vinduespudsning" element={<VinduespudsningPage />} />
            <Route path="/solcellevask" element={<SolcellevaskPage />} />
            <Route path="/fliserens" element={<FliserensPage />} />
            <Route path="/daekningsomraader" element={<CitiesOverviewPage />} />
            <Route path="/byer" element={<Navigate to="/daekningsomraader" replace />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            
            {/* 9 Dedicated SEO Location Pages */}
            <Route
              path="/vinduespudser-slagelse"
              element={<CityPage cityData={CITY_PAGES.slagelse} />}
            />
            <Route
              path="/vinduespudser-slots-bjergby"
              element={<CityPage cityData={CITY_PAGES.slotsbjergby} />}
            />
            <Route
              path="/vinduespudser-soroe"
              element={<CityPage cityData={CITY_PAGES.soroe} />}
            />
            <Route
              path="/vinduespudser-skaelskoer"
              element={<CityPage cityData={CITY_PAGES.skaelskoer} />}
            />
            <Route
              path="/vinduespudser-dalmose"
              element={<CityPage cityData={CITY_PAGES.dalmose} />}
            />
            <Route
              path="/vinduespudser-naestved"
              element={<CityPage cityData={CITY_PAGES.naestved} />}
            />
            <Route
              path="/vindusepudser-karrebaeksminde"
              element={<CityPage cityData={CITY_PAGES.karrebaeksminde} />}
            />
            {/* Alias with standard spelling */}
            <Route
              path="/vinduespudser-karrebaeksminde"
              element={<Navigate to="/vindusepudser-karrebaeksminde" replace />}
            />
            <Route
              path="/vinduespudser-ringsted"
              element={<CityPage cityData={CITY_PAGES.ringsted} />}
            />
            <Route
              path="/vinduespudser-hoeng"
              element={<CityPage cityData={CITY_PAGES.hoeng} />}
            />
            <Route
              path="/vindusepudser-fuglebjerg"
              element={<CityPage cityData={CITY_PAGES.fuglebjerg} />}
            />
            {/* Alias with standard spelling */}
            <Route
              path="/vinduespudser-fuglebjerg"
              element={<Navigate to="/vindusepudser-fuglebjerg" replace />}
            />

            {/* Legal & Sub Pages */}
            <Route path="/handelsbetingelser" element={<TermsPage />} />
            <Route path="/privatlivspolitik" element={<PrivacyPage />} />
            <Route path="/tester" element={<Navigate to="/vinduespudsning" replace />} />

            {/* Error Pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
